import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTokenInterceptor } from './interceptors';

import {
  ApiService, JwtService
} from './services';
import { CustomToastrComponent } from './toastr/app-toastr/custom-toastr/custom-toastr.component';
import { SellerPortalInterceptor } from './interceptors/sp.interceptor';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    ApiService,
    JwtService,
    { provide: HTTP_INTERCEPTORS, useClass: SellerPortalInterceptor, multi: true }
  ],
  declarations: [CustomToastrComponent]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
